
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { Modal, Form, Input, Space, Button, Upload, TreeSelect, Select, message, Row, Col, Radio, RadioChangeEvent } from 'antd'
import { useForm } from "antd/lib/form/Form"
import { DeleteOutlined, PlusOutlined, EditOutlined } from '@ant-design/icons'
import { axiosHandleEvent, baseAxiosNoInfo } from '../../tool/axios'
import { XinTool } from '../../tool/xinTool'
import { apiPrefix } from '../../js/config'
import { formItemLayout, tailLayout } from '../../js/globalParam'
import { pointMoreThanTwo } from '../../js/number'
import { Base64 } from 'js-base64'
import Cookies from 'js-cookie'
import E from 'wangeditor'
import _ from 'lodash'

const { Option } = Select
const { TextArea } = Input

const uploadFile = (e: { file: any, fileList: [] }) => {
    if (Array.isArray(e)) {
        return e
    }

    if (e.file.size < 300000) {
        return e && e.fileList

    } else {
        let r = e.fileList.every((el: any) => {
            return el.size < 300000
        })

        if (r) {
            return e.fileList
        }
    }
}

const uploadButton = (
    <div>
        <PlusOutlined />
        <div style={{ marginTop: 8 }}>Upload</div>
    </div>
)

type TreeData = {
    title: string, // '产康分类1'
    value: string, // '0-0'
    key: string, // '0-0'
    children: {
        title: string, // '项目1'
        value: string, //  '0-0-0'
        key: string, // '0-0-0'
    }[]
}

type flag = { id: number, label_name: string, label_color: string }
type memberGrade = { id: number, grade_name: string }

type extraItem = { id: string, item_name: string, standard_times: number, up_limit_times: number }
type historyExtraItem = { id: string, item_id: string, item_name: string, standard_times: number, up_limit_times: number }

export default function AddEdit() {

    const [form] = useForm()
    const [requesting, setRequesting] = useState<boolean>(false)
    const [fileList, setFileList] = useState<any[]>([])

    const [treeData, setTreeData] = useState<TreeData[]>([])
    const [treeDataOrigin, setTreeDataOrigin] = useState<any[]>([])
    const [treeDataOneRow, setTreeDataOneRow] = useState<any[]>([])

    const [editorVisible, setEditorVisible] = useState<boolean>(false)
    const [editor, setEditor] = useState<null | E>(null)
    const [editType, setEditType] = useState<string>('')

    const [ckSelected, setCkSelected] = useState<string[]>([])
    const [ckSelectedJson, setCkSelectedJson] = useState<any[]>([])

    const [pageTitle, setPageTitle] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)

    const [errorTimes, setErrorTimes] = useState<boolean>(false)
    const [projectRequired, setProjectRequired] = useState<boolean>(false)
    const [historyCheckedList, setHistoryCheckedList] = useState<any[]>([])

    const [tagList, setTagList] = useState<flag[]>([])
    const [memberGradeList, setMemberGradeList] = useState<memberGrade[]>([])

    const [memberGradeId, setMemberGradeId] = useState<string>('')

    const [givingItemRestrict, setGivingItemRestrict] = useState<number>(0)
    const [ckSelected2, setCkSelected2] = useState<string[]>([])
    const [ckSelectedJson2, setCkSelectedJson2] = useState<any[]>([])

    const [upgradeCost, setUpgradeCost] = useState<number>(0)
    const [activityItem, setActivityItem] = useState<number>(0)
    const [historyCheckedList2, setHistoryCheckedList2] = useState<any[]>([])

    let { id }: { id: string } = useParams()

    useEffect(() => {
        // 查询项目标签
        baseAxiosNoInfo.get('/global/flag_pool_list', { params: { flag_type: 1 } }).then((response: any) => {
            if (response) setTagList(response)
        })

        // 查询产康单项
        baseAxiosNoInfo.get('/global/chankang_single_list').then((response: any) => {
            if (response) {
                const handleData = (res: any) => {
                    let result: any[] = []

                    res.forEach((element: any) => {
                        result.push(element)

                        if (element.children) {
                            result.push(...handleData(element.children))
                        }
                    })

                    return result
                }

                setTreeDataOrigin(response)
                setTreeDataOneRow(handleData(response))
                setTreeData(translateToTreeData(response))
            }
        })

        // 查询会员等级
        baseAxiosNoInfo.get('/global/member_grade_list').then((response: any) => {
            if (response) setMemberGradeList(response)
        })

        if (id) {
            baseAxiosNoInfo.get('/yuezi_center/package/detail', {
                params: { id }

            }).then((res: any) => {
                if (!res) {
                    message.error('查无数据');
                    window.history.go(-1);
                    return
                }

                let formData: any = {
                    item_name: res.item_name,
                    item_intro_simple: res.item_intro_simple,
                    suggest_price: res.suggest_price,
                    label_list: res.label_list.map((el: any) => ({ value: el.label_color, label: el.label_name })),
                    item_pic_url: res.item_pic_url.split(',').map((el: any) => ({ url: el, uid: el, response: { data: [el] } })),
                    item_intro_detail: Base64.fromBase64(res.item_intro_detail),
                    effect: Base64.fromBase64(res.effect),
                    item_type: res.item_type,
                    is_activity_item: res.is_activity_item,
                    member_grade_id: res.member_grade_id,
                    giving_item_restrict: res.giving_item_restrict,
                    giving_total_item_num: res.giving_total_item_num || 0,
                    giving_total_num: res.giving_total_num || 0,
                    giving_total_amount: res.giving_total_amount || 0,
                    nursing_care_type: res.nursing_care_type,
                    upgrade_cost: res.upgrade_cost,
                    item_day: res.item_day,
                    check_in_cost: res.check_in_cost,
                    hospital_nurse_day: res.hospital_nurse_day,
                    escort_cost: res.escort_cost
                }

                form.setFieldsValue(formData)

                setUpgradeCost(res.nursing_care_type)
                setActivityItem(res.is_activity_item)
                setGivingItemRestrict(res.giving_item_restrict)

                setHistoryCheckedList(res.item_list_extra)
                setHistoryCheckedList2(res.item_list_giving)

                setFileList(res.item_pic_url.split(',').map((el: any) => ({ url: el, uid: el, response: { data: [el] } })))
            })

            setProjectRequired(false)
            setPageTitle('编辑月子套餐')

        } else {
            setProjectRequired(true)
            setPageTitle('新增月子套餐')
        }
    }, [1])

    // 验证标准次数和上线次数
    useEffect(() => {
        if (ckSelectedJson.length > 0 && historyCheckedList.length > 0) {
            let hasSame: boolean = false

            ckSelectedJson.forEach((el: extraItem) => {
                hasSame = historyCheckedList.some((el2: historyExtraItem) => el.id === el2.item_id)
            })

            setErrorTimes(hasSame)

        } else {
            setErrorTimes(false)
        }
    }, [ckSelectedJson, historyCheckedList])

    useEffect(() => {
        let arr: {}[] = []

        ckSelected.forEach(el => {
            treeDataOneRow.forEach((el2: any) => {
                if (el2.id === el) {
                    arr.push(el2)
                }
            })
        })

        setCkSelectedJson(arr)
    }, [ckSelected])


    useEffect(() => {
        let arr: {}[] = []

        ckSelected2.forEach(el => {
            treeDataOneRow.forEach((el2: any) => {
                if (el2.id === el) {
                    arr.push(el2)
                }
            })
        })

        setCkSelectedJson2(arr)
    }, [ckSelected2])

    const handleHistoryProjectChange = (index: number, attr: string, value: string) => {
        let list = _.cloneDeep(historyCheckedList)
        list[index][attr] = value

        setHistoryCheckedList(list)
    }

    const handleHistoryProjectDel = (index: number) => {
        let list = _.cloneDeep(historyCheckedList)
        list.splice(index, 1)

        setHistoryCheckedList(list)
    }

    const handleHistoryProjectChange2 = (index: number, attr: string, value: string) => {
        let list = _.cloneDeep(historyCheckedList2)
        list[index][attr] = value

        setHistoryCheckedList2(list)
    }

    const handleHistoryProjectDel2 = (index: number) => {
        let list = _.cloneDeep(historyCheckedList2)
        list.splice(index, 1)

        setHistoryCheckedList2(list)
    }

    const handleTreeSelectChange = (value: string[]) => {
        setCkSelected(value)
    }

    const handleTreeSelectChange2 = (value: string[]) => {
        setCkSelected2(value)
    }

    const showEditModal = (which: string) => {
        setEditType(which)
        setEditorVisible(true)

        if (editor === null) {
            setTimeout(() => {
                renderEditor((e: E) => {
                    which === 'service' ? e?.txt.html(form.getFieldValue('item_intro_detail')) : e?.txt.html(form.getFieldValue('effect'))
                })
            }, 200)

        } else {
            which === 'service' ? editor?.txt.html(form.getFieldValue('item_intro_detail')) : editor?.txt.html(form.getFieldValue('effect'))
        }
    }

    const renderEditor = (fn: Function) => {
        const editor = new E('.editor')

        editor.config.uploadFileName = "files"
        editor.config.uploadImgServer = apiPrefix + '/global/upload_pic'
        editor.config.uploadImgParams = {
            fileType: '1',
            bucketType: '4'
        }

        editor.config.uploadImgHeaders = {
            token: Cookies.get('token') || ''
        }
        editor.config.uploadImgHooks = {
            // 例如：服务器端返回的不是 { errno: 0, data: [...] } 这种格式，可使用 customInsert
            customInsert: function (insertImgFn: any, result: any) {
                // result 即服务端返回的接口
                insertImgFn(result.data[0])
            }
        }
        editor.create()

        setEditor(editor)
        fn(editor)
    }

    const handleModalOk = () => {
        let html = editor?.txt.html()
        editType === 'service' ? form.setFieldsValue({ item_intro_detail: html }) : form.setFieldsValue({ effect: html })

        setEditorVisible(false)
        editor?.txt.html('')
    }

    // 提交事件
    const onFinish = (values: any) => {
        if (!requesting) {
            let item_list_extra: any[] = []
            let item_list_giving: any[] = []

            let treeDataArr = _.cloneDeep(ckSelectedJson)
            let treeDataArr2 = _.cloneDeep(ckSelectedJson2)

            if (values.item_list_extra) {
                values.item_list_extra.forEach((el: any) => {
                    treeDataArr.forEach((el2: any) => {
                        if (el === el2.id) {
                            item_list_extra.push({
                                item_id: el2.id,
                                standard_times: el2.standard_times,
                                up_limit_times: el2.up_limit_times
                            })
                        }
                    })
                })
            }

            if (values.item_list_giving) {
                values.item_list_giving.forEach((el: any) => {
                    treeDataArr2.forEach((el2: any) => {
                        if (el === el2.id) {
                            item_list_giving.push({
                                item_id: el2.id,
                                up_limit_times: el2.up_limit_times,
                                up_limit_amount: el2.up_limit_amount
                            })
                        }
                    })
                })
            }

            let url: string = '',
                postData: any = {
                    item_name: values.item_name,
                    item_intro_detail: Base64.toBase64(values.item_intro_detail),
                    item_intro_simple: values.item_intro_simple,
                    label_list: values.label_list.map((el: { key: string, label: string, value: string }) => ({ label_name: el.label, label_color: el.value })),
                    effect: Base64.toBase64(values.effect),
                    suggest_price: values.suggest_price,
                    item_pic_url: (values.item_pic_url.map((el: any) => (el.response.data[0]))).join(','),
                    item_list_extra,
                    item_type: values.item_type,
                    giving_item_restrict: values.giving_item_restrict,
                    giving_total_item_num: values.giving_total_item_num || 0,
                    giving_total_num: values.giving_total_num || 0,
                    giving_total_amount: values.giving_total_amount || 0,
                    item_list_giving,
                    nursing_care_type: values.nursing_care_type,
                    upgrade_cost: values.upgrade_cost,
                    item_day: values.item_day,
                    check_in_cost: values.check_in_cost,
                    hospital_nurse_day: values.hospital_nurse_day,
                    escort_cost: values.escort_cost,
                    is_activity_item: values.is_activity_item,
                    member_grade_id: memberGradeId,
                }

            if (!id) {
                // 新增月子套餐
                url = '/yuezi_center/package/add'
                axiosHandleEvent.post(url, { ...postData })

            } else {
                // 编辑月子套餐
                url = '/yuezi_center/package/update'
                postData.id = id

                if (postData.item_list_extra.length === 0 && historyCheckedList.length === 0) {
                    message.error('产康项目和历史产康项目不能全部为空')
                    return
                }

                if (ckSelectedJson.length === 0) {
                    postData.item_list_extra = _.cloneDeep(historyCheckedList)

                } else {
                    historyCheckedList.forEach((el: any) => {
                        ckSelectedJson.forEach((el2: extraItem) => {
                            if (el2.id === el.id) {
                                message.error('产康项目和历史产康项目不能有相同项目')

                            } else {
                                postData.item_list_extra.push(el)
                            }
                        })
                    })
                }

                if (ckSelectedJson2.length === 0) {
                    postData.item_list_giving = _.cloneDeep(historyCheckedList2)

                } else {
                    historyCheckedList2.forEach((el: any) => {
                        ckSelectedJson2.forEach((el2: extraItem) => {
                            if (el2.id === el.id) {
                                message.error('产康项目和历史产康项目不能有相同项目')
                            } else {
                                postData.item_list_giving.push(el)
                            }
                        })
                    })
                }

                axiosHandleEvent.post(url, { ...postData })
            }
        }
    }

    const translateToTreeData = (data: { type_name: string, id: string, children: [] }[]): TreeData[] => {
        return data.map(el => ({
            title: el.type_name, // '产康分类1'
            value: el.id, // '0-0'
            key: el.id, // '0-0'
            children: el.children.map((el: { id: string, item_name: string }) => ({
                title: el.item_name, // '项目1'
                value: el.id, //  '0-0-0'
                key: el.id, // '0-0-0'
            }))
        }))
    }

    const deleteTreeOption = (id: string) => {
        let item_list_extra = XinTool.arrayDelByItem(ckSelected, id)

        setCkSelected(item_list_extra)
        form.setFieldsValue({ item_list_extra })
    }

    const deleteTreeOption2 = (id: string) => {
        let item_list_giving = XinTool.arrayDelByItem(ckSelected2, id)

        setCkSelected2(item_list_giving)
        form.setFieldsValue({ item_list_giving })
    }

    const handleProjectChange = (e: { target: { value: string } }, index: number, attr: string) => {
        let newArr = _.cloneDeep(ckSelectedJson)
        newArr[index][attr] = e.target.value

        setCkSelectedJson(newArr)
    }

    const handleProjectChange2 = (e: { target: { value: string } }, index: number, attr: string) => {
        let newArr = _.cloneDeep(ckSelectedJson2)
        newArr[index][attr] = e.target.value

        setCkSelectedJson2(newArr)
    }

    const handleFileChange = ({ fileList }: { fileList: any }) => {
        setFileList(fileList)

        form.setFieldsValue({
            item_pic_url: fileList
        })
    }

    const handleSelectChange = (value: any, attr: string) => {
        if (attr === 'member_grade_id') {
            setMemberGradeId(value.key);
        }
    }

    const flagValid = (_: any, value: flag[]) => {
        if (!value || value.length > 3 || value.length === 0) {
            return Promise.reject('标签数量不能少于1个或多于3个')
        }

        return Promise.resolve()
    }

    const priceValid = (_: any, value: number) => {
        if (value <= 0 || pointMoreThanTwo(value)) {
            return Promise.reject('价格必须大于0，如果价格含小数则只支持2位小数')
        }

        return Promise.resolve()
    }

    const tagOptions = tagList.map((el: flag) => (
        <Option value={el.label_color} key={el.id} >{el.label_name}</Option>
    ))

    const memberGradeOptions = memberGradeList.map((el: memberGrade) => (
        <Option value={el.id} key={el.id} >{el.grade_name}</Option>
    ))

    return <div className="common-level2-edit">
        {/* 月子中心 -> 月子项目管理 -> 月子套餐管理 -> 新增或编辑 */}
        <h2>{pageTitle}</h2>

        <div className="common-main">
            <Form {...formItemLayout} form={form} name="validate_editor" onFinish={onFinish} >
                <Form.Item label="套餐类型" name="item_type" rules={[{ required: true, message: '必须选择套餐类型' }]}>
                    <Radio.Group >
                        <Radio value={1}>月子套餐</Radio>
                        <Radio value={2}>月嫂套餐</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item label="套餐名称" name="item_name" rules={[{ required: true, message: '必须填写套餐名称' }]}  >
                    <Input />
                </Form.Item>

                <Form.Item label="套餐简介" name="item_intro_simple" rules={[{ required: true, message: '必须填写套餐简介' }]}  >
                    <TextArea />
                </Form.Item>

                <Form.Item
                    label="套餐图片"
                    valuePropName="fileList"
                    getValueFromEvent={uploadFile}
                    name="item_pic_url"
                    rules={[{ required: true, message: '必须上传套餐图片，并且每张图不能大于3M!' }]}
                >
                    <Upload
                        name="files"
                        data={{ fileType: 1, bucketType: 4 }}
                        action={apiPrefix + '/global/upload_pic'}
                        listType="picture-card"
                        onChange={handleFileChange}
                        beforeUpload={file => {
                            setLoading(true)

                            const isLt = file.size < 3000000;
                            if (!isLt) {
                                message.error('每张图不能大于3M!')
                                setLoading(false)
                                return false

                            } else {
                                return true
                            }
                        }}
                    >
                        {fileList.length >= 6 ? null : uploadButton}
                    </Upload>
                </Form.Item>

                <Form.Item
                    label="产康项目"
                    name="item_list_extra"
                    rules={[{ required: projectRequired, message: '必须选择当前产康项目' }]}>
                    <TreeSelect showSearch virtual={false} placeholder="请选择产康项目" treeData={treeData} treeCheckable={true} onChange={handleTreeSelectChange} filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)} />
                </Form.Item>

                {ckSelectedJson.length > 0 && <Form.Item label="选中产康项目">
                    <div className="checked-ck-projects">
                        <Row gutter={0} className="title">
                            <Col span="6">已选项目</Col>
                            <Col span="6">标准次数</Col>
                            <Col span="6">上限次数</Col>
                            <Col span="4">删除</Col>
                        </Row>

                        {ckSelectedJson.map((el: any, index: number) => (<Row gutter={0} className="content">
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_name}</Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写次数并为正整数" style={{ width: '90%' }} value={el.standard_times} onChange={(e: any) => { handleProjectChange(e, index, 'standard_times') }} /></Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写次数并为正整数" style={{ width: '90%' }} value={el.up_limit_times} onChange={(e: any) => { handleProjectChange(e, index, 'up_limit_times') }} /></Col>
                            <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteTreeOption(el.id) }} /></Col>
                        </Row>))}

                        {errorTimes && <p style={{ color: 'red', paddingLeft: '34px' }}>当前产康项目和历史产康项目不能有重叠</p>}
                    </div>
                </Form.Item>}

                {historyCheckedList.length > 0 && <Form.Item label="历史产康项目">
                    <div className="checked-ck-projects">
                        <Row gutter={0} className="title">
                            <Col span="6">已选项目</Col>
                            <Col span="6">项目类型</Col>
                            <Col span="4">标准次数</Col>
                            <Col span="4">上限次数</Col>
                            <Col span="4">删除</Col>
                        </Row>

                        {historyCheckedList.map((el: any, index: number) => (<Row gutter={0} className="content">
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_name}</Col>
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_label_desc}</Col>
                            <Col span="4"><Input min={1} style={{ width: '90%' }} value={el.standard_times} onChange={(e: any) => { handleHistoryProjectChange(index, 'standard_times', e.target.value) }} /></Col>
                            <Col span="4"><Input min={1} style={{ width: '90%' }} value={el.up_limit_times} onChange={(e: any) => { handleHistoryProjectChange(index, 'up_limit_times', e.target.value) }} /></Col>
                            <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { handleHistoryProjectDel(index) }} /></Col>
                        </Row>))}

                        {errorTimes && <p style={{ color: 'red', paddingLeft: '34px' }}>当前产康项目和历史产康项目不能有重叠</p>}
                    </div>
                </Form.Item>}

                <Form.Item label="是否赠送产康项目" name="giving_item_restrict"  >
                    <Radio.Group onChange={(v: RadioChangeEvent) => {
                        setGivingItemRestrict(v.target.value)
                    }}>
                        <Radio value={0}>不限制</Radio>
                        <Radio value={1}>限制</Radio>
                    </Radio.Group>
                </Form.Item>

                {givingItemRestrict === 1 && <Form.Item
                    label="限制项目总数" name="giving_total_item_num"
                >
                    <Input />
                </Form.Item>}

                {givingItemRestrict === 1 && <Form.Item
                    label="限制项目总次数" name="giving_total_num"
                >
                    <Input />
                </Form.Item>}

                {givingItemRestrict === 1 && <Form.Item
                    label="限制项目总金额" name="giving_total_amount"
                >
                    <Input />
                </Form.Item>}

                <Form.Item
                    label="赠送产康项目"
                    name="item_list_giving"
                >
                    <TreeSelect showSearch virtual={false} placeholder="请选择赠送产康项目" treeData={treeData} treeCheckable={true} onChange={handleTreeSelectChange2} filterTreeNode={(inputValue: any, treeNode: any) => (treeNode.title.indexOf(inputValue) != -1)} />
                </Form.Item>

                {ckSelectedJson2.length > 0 && <Form.Item label="选中赠送产康项目" >
                    <div className="checked-ck-projects">
                        <Row gutter={0} className="title">
                            <Col span="6">已选项目</Col>
                            <Col span="6">上限次数</Col>
                            <Col span="6">上限金额</Col>
                            <Col span="4">删除</Col>
                        </Row>

                        {ckSelectedJson2.map((el: any, index: number) => (<Row gutter={0} className="content">
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_name}</Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写次数并为正整数" style={{ width: '90%' }} value={el.up_limit_times} onChange={(e: any) => { handleProjectChange2(e, index, 'up_limit_times') }} /></Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写金额并为正整数" style={{ width: '90%' }} value={el.up_limit_amount} onChange={(e: any) => { handleProjectChange2(e, index, 'up_limit_amount') }} /></Col>
                            <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { deleteTreeOption2(el.id) }} /></Col>
                        </Row>))}
                    </div>
                </Form.Item>}

                {historyCheckedList2.length > 0 && <Form.Item label="历史赠送产康项目" >
                    <div className="checked-ck-projects">
                        <Row gutter={0} className="title">
                            <Col span="6">已选项目</Col>
                            <Col span="6">上限次数</Col>
                            <Col span="6">上限金额</Col>
                            <Col span="4">删除</Col>
                        </Row>

                        {historyCheckedList2.map((el: any, index: number) => (<Row gutter={0} className="content">
                            <Col span="6" style={{ lineHeight: '30px' }}>{el.item_name}</Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写次数并为正整数" style={{ width: '90%' }} value={el.up_limit_times} onChange={(e: any) => { handleHistoryProjectChange2(index, 'up_limit_times', e.target.value) }} /></Col>
                            <Col span="6"><Input min={1} type="number" required placeholder="填写金额并为正整数" style={{ width: '90%' }} value={el.up_limit_amount} onChange={(e: any) => { handleHistoryProjectChange2(index, 'up_limit_amount', e.target.value) }} /></Col>
                            <Col span="4"><DeleteOutlined style={{ cursor: 'pointer', color: 'red' }} onClick={() => { handleHistoryProjectDel2(index) }} /></Col>
                        </Row>))}
                    </div>
                </Form.Item>}

                <Form.Item label="护理模式" name="nursing_care_type" rules={[{ required: true, message: '必须选择护理模式' }]}>
                    <Radio.Group onChange={(v: RadioChangeEvent) => {
                        setUpgradeCost(v.target.value)
                    }}>
                        <Radio value={1}>一对一</Radio>
                        <Radio value={2}>托管</Radio>
                    </Radio.Group>
                </Form.Item>

                {upgradeCost === 1 && <Form.Item
                    label="升级一对一成本" name="upgrade_cost" rules={[{ required: true, message: '必须输入一对一成本' }]}
                >
                    <Input />
                </Form.Item>}

                {<Form.Item
                    label="套餐天数" name="item_day" rules={[{ required: true, message: '必须输入套餐天数' }]}
                >
                    <Input />
                </Form.Item>}

                {<Form.Item
                    label="医院护理天数" name="hospital_nurse_day" rules={[{ required: true, message: '必须输入默认医院护理天数' }]}
                >
                    <Input />
                </Form.Item>}

                {<Form.Item
                    label="入住一天成本" name="check_in_cost" rules={[{ required: true, message: '必须输入入住一天成本' }]}
                >
                    <Input />
                </Form.Item>}

                {<Form.Item
                    label="陪护一天成本" name="escort_cost" rules={[{ required: true, message: '必须输入陪护一天成本' }]}
                >
                    <Input />
                </Form.Item>}

                <Form.Item
                    label="套餐标签（可多选）" name="label_list"
                    rules={[{ validator: flagValid }]}
                >
                    <Select virtual={false} labelInValue={true} mode="tags" style={{ width: '50%' }} placeholder="请选择标签" >
                        {tagOptions}
                    </Select>
                </Form.Item>

                <Form.Item label="参考价格（元）" name="suggest_price"
                    rules={[{ validator: priceValid }]} >
                    <Input placeholder="请填写参考价格" type="number" />
                </Form.Item>

                <Form.Item label="产康功效" name="effect" rules={[{ required: true, message: '必须编辑产康功效' }]}  >
                    <Button onClick={() => { showEditModal('effect') }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item label="服务详情" name="item_intro_detail" rules={[{ required: true, message: '必须编辑服务详情' }]} >
                    <Button onClick={() => { showEditModal('service') }} icon={<EditOutlined />}>编辑</Button>
                </Form.Item>

                <Form.Item label="是否活动套餐" name="is_activity_item" rules={[{ required: true, message: '请选择是否活动套餐' }]}>
                    <Radio.Group onChange={(v: RadioChangeEvent) => {
                        setActivityItem(v.target.value)

                        if (v.target.value === 0) {
                            setMemberGradeId('')
                        }
                    }}>
                        <Radio value={1}>是</Radio>
                        <Radio value={0}>否</Radio>
                    </Radio.Group>
                </Form.Item>

                {activityItem === 1 && <Form.Item label="活动会员等级" name="member_grade_id" >
                    <Select virtual={false} labelInValue={true} style={{ width: '50%' }} onChange={(el: any) => { handleSelectChange(el, "member_grade_id") }}>
                        {memberGradeOptions}
                    </Select>
                </Form.Item>}

                <Form.Item {...tailLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">提交</Button>
                        <Button onClick={() => { window.history.go(-1) }} >返回</Button>
                    </Space>
                </Form.Item>
            </Form>
        </div>

        <Modal visible={editorVisible} onCancel={() => { setEditorVisible(false); editor?.txt.html('') }} width="800px" onOk={handleModalOk}>
            <div className="editor" style={{ marginTop: 50 }}></div>
        </Modal>
    </div>
}